"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var videoplayer_device_1 = require("@svt/videoplayer-device");

var assign_1 = __importDefault(require("core-js/library/fn/object/assign"));
/**
 * Based on https://stackoverflow.com/a/901144/86298
 */


var getParameterByName = function getParameterByName(name, url) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var results = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)').exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

var getAltUrl = function getAltUrl(url) {
  // Use URL API if available
  if (typeof URL !== 'undefined' && typeof URLSearchParams !== 'undefined') {
    try {
      return new URL(url).searchParams.get('alt');
    } catch (e) {
      return null;
    }
  } // Fallback to regex matching


  return getParameterByName('alt', url);
};
/**
 * Rewrite video references to use alt urls.
 */


exports.useAltUrls = function (streamInfo, win) {
  if (!videoplayer_device_1.supportsResponseURL() || videoplayer_device_1.isHbbTV(win)) {
    return streamInfo;
  }

  var videoReferences = {};
  Object.keys(streamInfo.videoReferences).forEach(function (key) {
    var altUrl = getAltUrl(streamInfo.videoReferences[key]);
    videoReferences[key] = altUrl || streamInfo.videoReferences[key];
  });
  return assign_1["default"]({}, streamInfo, {
    videoReferences: videoReferences
  });
};

exports["default"] = exports.useAltUrls;